// import { React } from "react";
import { useSelector } from "react-redux";
// import Carousel from "react-multi-carousel";
import { GoArrowRight } from "react-icons/go";
import "react-multi-carousel/lib/styles.css";
import { Link } from "react-router-dom";

const Banner = () => {
  const { categorys } = useSelector((state) => state.home);

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 1,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };
  return (
    <div className="w-full mx-auto bg-secondary h-[calc(100vh-120px)] md:h-[600px]">
      <div className="flex relative flex-col h-full items-center w-full bg-gradient-to-b from-[#75332A] to-secondary/10">
        <div className="container mt-[5%] md:mt-[10%] flex justify-between md:items-center lg:flex-col">
          {/* main heading */}
          <div className="md:text-center">
            <h1 className="text-primaryBackground lg:ml-0 ml-14 font-medium text-[42px] md:text-4xl leading-10">
              Discover Sellers.<br className="sm:block hidden" /> Connect Directly.
            </h1>
            <h1 className="text-primaryBackground text-[42px] font-medium md:hidden md:text-2xl md:leading-8">
              Support local businesses.
            </h1>
          </div>
          {/* action button */}
          <div className="max-w-[360px] lg:mt-6">
            <h4 className="text-primaryBackground text-2xl md:text-lg md:text-center">
              Built to support local sellers. No commissions. No middlemen
            </h4>
            <a href="https://seller.apnaplaza.store/register" target="_blank" rel="noopener noreferrer">
              <button className="mt-6 w-fit flex gap-x-2 !rounded-full bg-primaryBackground text-secondary py-3 px-6 font-medium hover:bg-primaryBackground hover:shadow-lg transition-all md:mx-auto">
                Become Seller
                <GoArrowRight className="text-2xl" />
              </button>
            </a>
          </div>
        </div>
        <div className=" absolute bottom-0 md:bottom-0 lg:bottom-0 left-1/2 transform -translate-x-1/2">
          <img
            src="/images/graphic.png"
            className="md:w-[350px] xl:w-[400px] xl-2xl:w-[500px] w-[600px] md:max-w-[350px]"
            alt="apna-plaza"
          />
        </div>
        <div className="mt-auto">
          <div className="w-full -mb-10 md:-mb-0">
            <img
              src="/images/apna-plaza-text.png"
              className="w-full"
              alt="apna-plaza"
            />
          </div>
          <div className="w-full h-[170px] md:h-[130px] z-1 bg-primaryBackground "></div>
        </div>
      </div>
      <div className="w-full flex gap-3 lg:justify-center md-lg:gap-8">
        {/* <div className='w-[20%] my-5  md:hidden lg:hidden'>
                        <div className='bg-white drop-shadow-md relative'>
                            <div className='overflow-hidden transition-all  rounded-[20px] duration-500 absolute z-[99999] bg-white w-full h-[calc(100vh-200px)] border-x'>
                                <h2 className=' text-[#1e2951] px-[24px] pt-[20px] pb-[10px] font-semibold'>Categories</h2>
                                <ul className='py-2 text-slate-600 transition-all duration-500 font-medium h-full overflow-auto '>
                                    {categorys.map((c, i) => (
                                        <Link
                                            to={`/products?category=${c.name}`}
                                            key={i}
                                            className='flex justify-start items-center rounded-[10px] gap-2 px-[24px] py-[6px] hover:bg-green-100 hover:font-semibold hover:text-secondary'
                                        >
                                            <img src={c.image} className='w-[30px] h-[30px] rounded-full overflow-hidden' alt={c.name} />
                                            <p className='text-sm block '>{c.name}</p>
                                        </Link>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div> */}

        <div className="w-[100%] ">
          <div className="mb-6 overflow-hidden">
            {/* <img
              src="/images/banner.png"
              className="h-[calc(100vh-135px)] w-full"
              alt="apna-plaza-banner"
            /> */}
            {/* <div className='absolute z-20 w-full bg-black/[.1] h-full rounded-[20px] text-white font-bold text-5xl md:text-3xl sm:text-xl text-center flex flex-col gap-3 items-center justify-center'>
                                <h1 className=' text-white font-bold  text-center flex items-center justify-center '>Where modesty meets  </h1>
                                <span className='text-secondary flex items-center gap-2'> modernity<p className='animate-bounce mt-1'>!</p></span>
                            </div>
                            <div className='md:hidden lg:hidden'>
                                <Carousel

                                    className='rounded-[20px]'
                                    autoPlay={true}
                                    infinite={true}
                                    autoPlaySpeed={5000}
                                    arrows={false}
                                    showDots={false}
                                    responsive={responsive}
                                >
                                    {
                                        [1, 2, 3,].map((img, i) => <div className='lg:h-auto md:h-auto h-[350px] w-full  block' key={i} to='#'>

                                            <img className='object-cover w-full h-full ' src={`/images/banner/${img}.jpg`} alt="" />
                                        </div>)
                                    }
                                </Carousel>
                            </div>
                            <div className='md:block lg:block hidden '>
                                <Carousel

                                    className='rounded-[20px]'
                                    autoPlay={false}
                                    infinite={false}
                                    autoPlaySpeed={5000}
                                    arrows={false}
                                    showDots={false}
                                    responsive={responsive}
                                >
                                    {
                                        [5].map((img, i) => <div className='lg:h-auto md:h-auto  h-[350px] w-full  block' key={i} to='#'>

                                            <img className='object-cover w-full h-full ' src={`/images/banner/${img}.jpg`} alt="" />
                                        </div>)
                                    }
                                </Carousel>
                            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
